import { POSTThemeBody, PUTThemeBody } from '.'
import { IPaginatedRequest } from '@cbgms/api/request'

export const createInitialTheme = (data: POSTThemeBody) => ({
  method: 'POST',
  url: '/setup/initial-themes-setup',
  data
})

export const updateTheme = (data: PUTThemeBody) => ({
  method: 'PUT',
  url: '/modules/themes',
  data
})

export const listThemes = (params: IPaginatedRequest) => ({
  method: 'GET',
  url: '/modules/themes',
  params
})

export const getThemeById = (themesUUID: string) => ({
  method: 'GET',
  url: `/modules/themes/${themesUUID}`
})

export const createTheme = (data: POSTThemeBody) => ({
  method: 'POST',
  url: '/modules/themes',
  data
})

export const updateThemeById = (themesUUID: string, data: PUTThemeBody) => ({
  method: 'PUT',
  url: `/modules/themes/${themesUUID}`,
  data
})

export const deleteTheme = (themesUUID: string, dryRun: boolean) => ({
  method: 'DELETE',
  url: `/modules/themes/${themesUUID}`,
  params: {
    dryRun
  }
})

export const supportListThemes = (params: IPaginatedRequest) => ({
  method: 'GET',
  url: '/support/themes',
  params
})

export const supportGetTheme = (themesUUID: string) => ({
  method: 'GET',
  url: `/support/themes/${themesUUID}`
})

export const supportCreateTheme = (data: POSTThemeBody) => ({
  method: 'POST',
  url: '/support/themes',
  data
})

export const supportUpdateTheme = (themesUUID: string, data: PUTThemeBody) => ({
  method: 'PUT',
  url: `/support/themes/${themesUUID}`,
  data
})

export const supportDeleteTheme = (themesUUID: string, dryRun: boolean) => ({
  method: 'DELETE',
  url: `/support/themes/${themesUUID}`,
  params: {
    dryRun
  }
})
